import { CommonModule } from '@angular/common';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import { ColorWrap, HueModule, SwatchModule } from 'ngx-color';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-color';
class SliderSwatchComponent {
    constructor() {
        this.first = false;
        this.last = false;
        this.onClick = new EventEmitter();
    }
    ngOnChanges() {
        this.background = `hsl(${this.hsl.h}, 50%, ${this.offset * 100}%)`;
    }
    handleClick($event) {
        this.onClick.emit({
            data: {
                h: this.hsl.h,
                s: 0.5,
                l: this.offset,
                source: 'hsl',
            },
            $event,
        });
    }
}
SliderSwatchComponent.ɵfac = function SliderSwatchComponent_Factory(t) { return new (t || SliderSwatchComponent)(); };
SliderSwatchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SliderSwatchComponent, selectors: [["color-slider-swatch"]], inputs: { first: "first", last: "last", hsl: "hsl", active: "active", offset: "offset" }, outputs: { onClick: "onClick" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 8, consts: [[1, "slider-swatch", 3, "click"]], template: function SliderSwatchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function SliderSwatchComponent_Template_div_click_0_listener($event) { return ctx.handleClick($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("background", ctx.background);
        ɵngcc0.ɵɵclassProp("first", ctx.first)("last", ctx.last)("active", ctx.active);
    } }, styles: [".slider-swatch[_ngcontent-%COMP%] {\n      height: 12px;\n      background: rgb(121, 211, 166);\n      cursor: pointer;\n    }\n    .slider-swatch.active[_ngcontent-%COMP%] {\n      transform: scaleY(1.8);\n      border-top-right-radius: 3.6px 2px;\n      border-top-left-radius: 3.6px 2px;\n      border-bottom-right-radius: 3.6px 2px;\n      border-bottom-left-radius: 3.6px 2px;\n    }\n    .slider-swatch.first[_ngcontent-%COMP%] {\n      border-radius: 2px 0px 0px 2px;\n    }\n    .slider-swatch.last[_ngcontent-%COMP%] {\n      border-radius: 0px 2px 2px 0px;\n    }"], changeDetection: 0 });
SliderSwatchComponent.propDecorators = {
    hsl: [{ type: Input }],
    active: [{ type: Input }],
    offset: [{ type: Input }],
    first: [{ type: Input }],
    last: [{ type: Input }],
    onClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SliderSwatchComponent, [{
        type: Component,
        args: [{ selector: 'color-slider-swatch', template: `
  <div class="slider-swatch" [style.background]="background"
    [class.first]="first" [class.last]="last" [class.active]="active"
    (click)="handleClick($event)"
  ></div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, preserveWhitespaces: false, styles: ["\n    .slider-swatch {\n      height: 12px;\n      background: rgb(121, 211, 166);\n      cursor: pointer;\n    }\n    .slider-swatch.active {\n      transform: scaleY(1.8);\n      border-top-right-radius: 3.6px 2px;\n      border-top-left-radius: 3.6px 2px;\n      border-bottom-right-radius: 3.6px 2px;\n      border-bottom-left-radius: 3.6px 2px;\n    }\n    .slider-swatch.first {\n      border-radius: 2px 0px 0px 2px;\n    }\n    .slider-swatch.last {\n      border-radius: 0px 2px 2px 0px;\n    }\n\n  "] }]
    }], function () { return []; }, { first: [{
            type: Input
        }], last: [{
            type: Input
        }], onClick: [{
            type: Output
        }], hsl: [{
            type: Input
        }], active: [{
            type: Input
        }], offset: [{
            type: Input
        }] }); })();

class SliderSwatchesComponent {
    constructor() {
        this.onClick = new EventEmitter();
        this.onSwatchHover = new EventEmitter();
    }
    active(l, s) {
        return (Math.round(this.hsl.l * 100) / 100 === l &&
            Math.round(this.hsl.s * 100) / 100 === s);
    }
    handleClick({ data, $event }) {
        this.onClick.emit({ data, $event });
    }
}
SliderSwatchesComponent.ɵfac = function SliderSwatchesComponent_Factory(t) { return new (t || SliderSwatchesComponent)(); };
SliderSwatchesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SliderSwatchesComponent, selectors: [["color-slider-swatches"]], inputs: { hsl: "hsl" }, outputs: { onClick: "onClick", onSwatchHover: "onSwatchHover" }, decls: 11, vars: 17, consts: [[1, "slider-swatches"], [1, "slider-swatch-wrap"], [3, "hsl", "offset", "active", "first", "onClick"], [3, "hsl", "offset", "active", "onClick"], [3, "hsl", "offset", "active", "last", "onClick"]], template: function SliderSwatchesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "color-slider-swatch", 2);
        ɵngcc0.ɵɵlistener("onClick", function SliderSwatchesComponent_Template_color_slider_swatch_onClick_2_listener($event) { return ctx.handleClick($event); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(3, "div", 1)(4, "color-slider-swatch", 3);
        ɵngcc0.ɵɵlistener("onClick", function SliderSwatchesComponent_Template_color_slider_swatch_onClick_4_listener($event) { return ctx.handleClick($event); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 1)(6, "color-slider-swatch", 3);
        ɵngcc0.ɵɵlistener("onClick", function SliderSwatchesComponent_Template_color_slider_swatch_onClick_6_listener($event) { return ctx.handleClick($event); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(7, "div", 1)(8, "color-slider-swatch", 3);
        ɵngcc0.ɵɵlistener("onClick", function SliderSwatchesComponent_Template_color_slider_swatch_onClick_8_listener($event) { return ctx.handleClick($event); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(9, "div", 1)(10, "color-slider-swatch", 4);
        ɵngcc0.ɵɵlistener("onClick", function SliderSwatchesComponent_Template_color_slider_swatch_onClick_10_listener($event) { return ctx.handleClick($event); });
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hsl", ctx.hsl)("offset", 0.8)("active", ctx.active(0.8, 0.5))("first", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hsl", ctx.hsl)("offset", 0.65)("active", ctx.active(0.65, 0.5));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hsl", ctx.hsl)("offset", 0.5)("active", ctx.active(0.5, 0.5));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hsl", ctx.hsl)("offset", 0.35)("active", ctx.active(0.35, 0.5));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hsl", ctx.hsl)("offset", 0.2)("active", ctx.active(0.2, 0.5))("last", true);
    } }, dependencies: [SliderSwatchComponent], styles: [".slider-swatches[_ngcontent-%COMP%] {\n      margin-top: 20px;\n    }\n    .slider-swatch-wrap[_ngcontent-%COMP%] {\n      box-sizing: border-box;\n      width: 20%;\n      padding-right: 1px;\n      float: left;\n    }"], changeDetection: 0 });
SliderSwatchesComponent.propDecorators = {
    hsl: [{ type: Input }],
    onClick: [{ type: Output }],
    onSwatchHover: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SliderSwatchesComponent, [{
        type: Component,
        args: [{ selector: 'color-slider-swatches', template: `
  <div class="slider-swatches">
    <div class="slider-swatch-wrap">
      <color-slider-swatch
        [hsl]="hsl"
        [offset]=".80"
        [active]="active(0.80, 0.50)"
        (onClick)="handleClick($event)"
        [first]="true"
      ></color-slider-swatch>
    </div>
    <div class="slider-swatch-wrap">
      <color-slider-swatch
        [hsl]="hsl"
        [offset]=".65"
        [active]="active(0.65, 0.50)"
        (onClick)="handleClick($event)"
      ></color-slider-swatch>
    </div>
    <div class="slider-swatch-wrap">
      <color-slider-swatch
        [hsl]="hsl"
        [offset]=".50"
        [active]="active(0.50, 0.50)"
        (onClick)="handleClick($event)"
      ></color-slider-swatch>
    </div>
    <div class="slider-swatch-wrap">
      <color-slider-swatch
        [hsl]="hsl"
        [offset]=".35"
        [active]="active(0.35, 0.50)"
        (onClick)="handleClick($event)"
      ></color-slider-swatch>
    </div>
    <div class="slider-swatch-wrap">
      <color-slider-swatch
        [hsl]="hsl"
        [offset]=".20"
        [active]="active(0.20, 0.50)"
        (onClick)="handleClick($event)"
        [last]="true"
      ></color-slider-swatch>
    </div>
  </div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, preserveWhitespaces: false, styles: ["\n    .slider-swatches {\n      margin-top: 20px;\n    }\n    .slider-swatch-wrap {\n      box-sizing: border-box;\n      width: 20%;\n      padding-right: 1px;\n      float: left;\n    }\n  "] }]
    }], function () { return []; }, { onClick: [{
            type: Output
        }], onSwatchHover: [{
            type: Output
        }], hsl: [{
            type: Input
        }] }); })();

class SliderComponent extends ColorWrap {
    constructor() {
        super();
        this.pointer = {
            width: '14px',
            height: '14px',
            borderRadius: '6px',
            transform: 'translate(-7px, -2px)',
            backgroundColor: 'rgb(248, 248, 248)',
            boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)',
        };
        this.radius = 2;
    }
    handlePickerChange({ data, $event }) {
        this.handleChange(data, $event);
    }
}
SliderComponent.ɵfac = function SliderComponent_Factory(t) { return new (t || SliderComponent)(); };
SliderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SliderComponent, selectors: [["color-slider"]], inputs: { pointer: "pointer", radius: "radius" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 7, consts: [[1, "slider-hue"], [3, "hsl", "radius", "pointer", "onChange"], [1, "slider-swatches"], [3, "hsl", "onClick"]], template: function SliderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 0)(2, "color-hue", 1);
        ɵngcc0.ɵɵlistener("onChange", function SliderComponent_Template_color_hue_onChange_2_listener($event) { return ctx.handlePickerChange($event); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(3, "div", 2)(4, "color-slider-swatches", 3);
        ɵngcc0.ɵɵlistener("onClick", function SliderComponent_Template_color_slider_swatches_onClick_4_listener($event) { return ctx.handlePickerChange($event); });
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("slider-picker ", ctx.className, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hsl", ctx.hsl)("radius", ctx.radius)("pointer", ctx.pointer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hsl", ctx.hsl);
    } }, dependencies: [ɵngcc1.HueComponent, SliderSwatchesComponent], styles: [".slider-hue[_ngcontent-%COMP%] {\n      height: 12px;\n      position: relative;\n    }"], changeDetection: 0 });
SliderComponent.ctorParameters = () => [];
SliderComponent.propDecorators = {
    pointer: [{ type: Input }],
    radius: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SliderComponent, [{
        type: Component,
        args: [{ selector: 'color-slider', template: `
  <div class="slider-picker {{ className }}">
    <div class="slider-hue">
      <color-hue
        [hsl]="hsl" [radius]="radius" [pointer]="pointer"
        (onChange)="handlePickerChange($event)"
      ></color-hue>
    </div>
    <div class="slider-swatches">
      <color-slider-swatches [hsl]="hsl"
        (onClick)="handlePickerChange($event)"
      ></color-slider-swatches>
    </div>
  </div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, preserveWhitespaces: false, styles: ["\n    .slider-hue {\n      height: 12px;\n      position: relative;\n    }\n  "] }]
    }], function () { return []; }, { pointer: [{
            type: Input
        }], radius: [{
            type: Input
        }] }); })();
class ColorSliderModule {
}
ColorSliderModule.ɵfac = function ColorSliderModule_Factory(t) { return new (t || ColorSliderModule)(); };
ColorSliderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ColorSliderModule });
ColorSliderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, HueModule, SwatchModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ColorSliderModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SliderComponent,
                    SliderSwatchComponent,
                    SliderSwatchesComponent,
                ],
                exports: [SliderComponent, SliderSwatchComponent, SliderSwatchesComponent],
                imports: [CommonModule, HueModule, SwatchModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ColorSliderModule, { declarations: function () { return [SliderComponent, SliderSwatchComponent, SliderSwatchesComponent]; }, imports: function () { return [CommonModule, HueModule, SwatchModule]; }, exports: function () { return [SliderComponent, SliderSwatchComponent, SliderSwatchesComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ColorSliderModule, SliderComponent, SliderSwatchComponent as ɵa, SliderSwatchesComponent as ɵb };

